<template lang="pug">
div(class="bg-gray-lighter lg:bg-transparent")
    button(
        @click="isCollapsed = !isCollapsed"
        class="w-full flex items-center gap-x-2 px-4 py-5 border-b lg:hidden"
    )
        span(class="relative")
            CartOutline(class="h-6 w-6 fill-current")
            span(
                class="absolute -top-1 left-2.5 Zright-[1px] font-bold text-center text-sm leading-none"
            ) {{ itemCount }}

        span(class="text-sm") {{ isCollapsed ? 'Show' : 'Hide' }} Summary
        ArrowIcon(class="h-2.5 w-.h-2.5 fill-current")

        p(class="ml-auto font-bold") {{ grandSubtotal }}

    div(
        class="grid transition-all duration-300 lg:transition-none lg:grid-rows-[1fr]"
        :class="[ isCollapsed ? 'grid-rows-[0fr]' : 'grid-rows-[1fr]' ]"
    )
        div(class="overflow-hidden")
            div(class="p-3 py-4 space-y-5 border-b lg:p-0 lg:border-none")
                Cart

                div
                    div(
                        v-if="checkoutData.summary.cartSubtotal !== checkoutData.summary.grandTotal"
                        class="flex justify-between text-sm"
                    )
                        p Subtotal
                        p(class="font-bold") {{ cartSubtotal }}

                    div(class="flex justify-between text-sm")
                        p Shipping
                        p {{ shippingSubtotal }}

                    div(
                        v-if="hasTax"
                        class="flex justify-between text-sm"
                    )
                        p Estimated Tax
                        p {{ taxSubtotal }}

                    div(class="flex justify-between pt-3 font-bold")
                        p {{ hasTax ? 'Grand' : 'Estimated'}} Total
                        p {{ grandSubtotal }}

</template>

<script>
import ArrowIcon from '@/assets/arrow?inline'
import CartOutline from '@/assets/common/cartOutline?inline'
import { formatCents } from '@/helpers/filters'
import Cart from './cart'

export default {
    name: 'Summary',
    components: {
        ArrowIcon,
        Cart,
        CartOutline,
    },
    data() {
        return {
            isCollapsed: true,
        }
    },
    computed: {
        checkoutData() {
            return this.$store.state.checkout.data
        },
        itemCount() {
            return this.$store.state.cart.data.itemCount || 0
        },
        cartSubtotal() {
            return formatCents(this.checkoutData.summary.cartSubtotal)
        },
        shippingSubtotal() {
            if (!this.checkoutData.summary.shippingSubtotal) return 'Free Shipping'

            return formatCents(this.checkoutData.summary.shippingSubtotal)
        },
        hasTax() {
            return !!(
                this.checkoutData.summary.taxSubtotal || this.checkoutData.billingContact?.zipcode
            )
        },
        taxSubtotal() {
            return formatCents(this.checkoutData.summary.taxSubtotal)
        },
        grandSubtotal() {
            return formatCents(this.checkoutData.summary.grandTotal)
        },
    },
}
</script>
